import Vue from 'vue';
const vue = new Vue({});

export default function auth({ next, router }) {
  if (vue.$localStorage.get('user')) {
    return router.push({ name: 'ListaDenuncias' });
  }

  return next();
}



// WEBPACK FOOTER //
// ./src/middleware/logged.js